import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";

async function inviteFormValidation(data: { form_id: string; validated_by: string }) {
    const { error } = await supabaseClient.rpc("invite_form_validation", {
        p_form_id: data.form_id,
        p_validated_by: data.validated_by,
    });
    if (error) throw error;
    return data;
}

async function inviteScheduleValidation(data: { schedule_id: string; validated_by: string }) {
    const { error } = await supabaseClient.rpc("invite_schedule_validation", {
        p_schedule_id: data.schedule_id,
        p_validated_by: data.validated_by,
    });
    if (error) throw error;
    return data;
}

export function useInviteFormValidation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["invite-form-validation"],
        mutationFn: inviteFormValidation,
        onSuccess: () => {
            toast.success("Validator invited");
            queryClient.invalidateQueries({ queryKey: ["validations"] });
        },
        onError: (error: Error) => {
            toast.error(error.message || "Could not invite a validator");
        },
    });
}

export function useInviteScheduleValidation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["invite-schedule-validation"],
        mutationFn: inviteScheduleValidation,
        onSuccess: () => {
            toast.success("Validator invited");
            queryClient.invalidateQueries({ queryKey: ["validations"] });
        },
        onError: (error: Error) => {
            toast.error(error.message || "Could not invite a validator");
        },
    });
}
